import React from "react";

import { SocialLinks as socialLinksConfig } from "config.js";

import "./SocialLinks.css";

function SocialLinks({ className }) {
  return (
    <div className={`social-links ${className || ""}`}>
      <a
        href={socialLinksConfig.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className="social-links__item"
      >
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="2" y="2" width="20" height="20" rx="5" stroke="#fff" strokeWidth="1.75" />
          <circle cx="12" cy="12" r="4.25" stroke="#fff" strokeWidth="1.75" />
          <circle cx="17.5" cy="6.5" r="1.25" fill="#fff" />
        </svg>
        <span className="social-links__label">Instagram</span>
      </a>

      <a
        href={socialLinksConfig.facebook}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        className="social-links__item"
      >
        <svg width="21" height="21" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="11" fill="#fff" />
          <path
            fill="#474747"
            d="M13.5 8.2h2.2V5.1h-2.2c-2.1 0-3.8 1.7-3.8 3.8V11H7.5v3.1h2.2V19h3.3v-4.9h2.2l.7-3.1h-2.9V8.9c0-.4.3-.7.7-.7z"
          />
        </svg>
        <span className="social-links__label">Facebook</span>
      </a>

      <a
        href={socialLinksConfig.x}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Twitter"
        className="social-links__item"
      >
        <svg width="18" height="18" viewBox="0 0 16 16" aria-hidden="true">
          <path
            fill="#fff"
            d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"
          />
        </svg>
        <span className="social-links__label">Twitter</span>
      </a>
    </div>
  );
}

export default SocialLinks;
